import styled from 'styled-components';
import Typography from '@/components/core/Typography/Typography';
import { Form } from 'formik';
import { FlexCol3XS } from '@/components/Flex';
import Button from '@/components/core/Button';
import { device } from '@/components/Media';

export const Root = styled.main`
    padding: 72px ${({ theme }) => theme.spacing['4xl']};
    min-height: 358px;
    height: 100%;
    display: grid;
    align-items: center;
    justify-content: center;
    border-radius: ${({ theme }) => theme.extras.radius.md};
    background-color: transparent;

    @media ${device.laptopS} {
        padding: 72px 0;
    }

    @media ${device.laptopS} {
        padding-top: 0;
        padding-bottom: 0;
        justify-content: stretch;
    }
`;

export const LayoutWithBannerWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    width: 100%;

    @media screen and ${device.laptopS} {
        grid-template-columns: 1fr;
    }
`;

export const GreyTypography = styled(Typography)`
    display: block;
    white-space: pre-line;
`;

export const Title = styled(Typography)`
    text-align: center;
    display: block;
    color: ${({ theme }) => theme.colors.palette.grey_800};
`;

export const StyledForm = styled(Form).attrs({
    method: 'post'
})`
    gap: ${({ theme }) => theme.spacing['2xs']};
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing['3xl']};

    @media screen and ${device.laptopS} {
        justify-content: center;
        gap: ${({ theme }) => theme.spacing['3xs']};
    }
`;

export const PageWrapper2VerticalSections = styled.div`
    display: grid;
    height: 100%;
    grid-template-rows: 1fr auto;
    align-content: center;
    justify-content: center;
    align-items: center;

    @media ${device.laptopS} {
        justify-content: stretch;
    }

    @media screen and ${device.laptopS} {
       grid-template-rows: auto 1fr auto;
    }
`;

export const StyledMainFrame = styled.div`
    gap: ${({ theme }) => theme.spacing['2xs']};
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing['3xl']};

    @media ${device.laptopS} {
        form {
            min-width: 420px;
        }
    }

    @media ${device.laptopS} {
        justify-content: center;
        gap: ${({ theme }) => theme.spacing['2xs']};
      
        form {
            width: 100%;
            min-width: unset;
        }
    }
`;

export const StyledSecondaryTitle = styled(FlexCol3XS)`
    text-align: center;
`;

export const Frame = styled.div`
    width: 420px;
    display: flex;
    flex-direction: column;
    gap: 30px;

    @media ${device.laptopS} {
        width: 100%;
        gap: ${({ theme }) => theme.spacing['2xs']};
    }
`;

export const WideFrame = styled(Frame)`
    && {
        width: 100%;
        flex: 1;
        justify-content: center;

        @media screen and ${device.laptopS} {
          flex: unset;
        }
    }
`;

export const ButtonsFrame = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing['xs']};

    @media ${device.laptopS} {
        width: 100%;
    }
`;

export const StyledButton = styled(Button)`
    height: 48px;
    padding-left: ${({ theme }) => theme.spacing['4xl']};
    padding-right: ${({ theme }) => theme.spacing['4xl']};

    @media ${device.laptopS} {
        width: 100%;
        justify-content: center;
    }
`;
